





import { computed, defineComponent, PropType } from "@vue/composition-api";
import { Banner } from "@scrile/api-provider/dist/api/BannersProvider";
import { MediaFilesController } from "@/lib/MediaFilesController";

export default defineComponent({
  name: "BannerItem",
  props: {
    banner: { type: Object as PropType<Banner>, required: true },
  },
  setup(props) {
    const ASPECT_RATIO = [5,1]
    const src = computed(() => MediaFilesController.getImageThumbnail(props.banner.image?.urlPart ?? "", "1080p"));
    const style = computed(() => ({
      "padding-bottom": (ASPECT_RATIO[1] / ASPECT_RATIO[0]) * 100 + "%" ?? "0",
    }));

    const url = computed(() => {
      if (props.banner.link.startsWith("http")) return props.banner.link;
      return `https://${props.banner.link}`
    })

    return { src, style, url }
  }
});
